import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../../shared/SectionTitle';
import RichEditor from '../../shared/RichEditor';
import styles from './styles.scss';
import messages from '../../../constants/messages';
import SectionDescription from '../../shared/SectionDescription';

const InterpretTestResult = ({ value, onChange, error }) => {
  return (
    <div>
      <SectionTitle title="How to Interpret Your Radon Test Results *" key="interpretTestResultTitle" />
      <RichEditor
        key="interpretRadonTestResult"
        initValue={value}
        onChange={(value) => onChange('interpretRadonTestResult', value)}
      />
      {error && <label className={styles.error}>{messages.validation.blankField}</label>}
      <SectionDescription
        className="mt-2"
        description="Only images uploaded from your local drive can be displayed in reports"
      />
    </div>
  );
};

InterpretTestResult.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
};

export default InterpretTestResult;



// WEBPACK FOOTER //
// src/components/reportContentLayout/InterpretTestResult/index.jsx